<template>
  <form @submit.prevent="handleSubmit" class="flex flex-col gap-y-4">
    <div class="text-5xl font-medium">
      {{ __('Edit Job Template') }}
    </div>

    <JobForm :data="data" :errors="errors" :is-job-template="true" />

    <TemplateSubmitSection
      :action-text="__('Update Template')"
      :isLoading="isLoading"
      :metadata="data.metadata"
      @update:status="data.metadata.status = $event"
      @updateAction="action = $event"
    />

  </form>
</template>
<script setup>
  import { reactive, ref } from 'vue';
  import JobForm from '../partials/JobForm.vue';
  import TemplateSubmitSection from './components/TemplateSubmitSection.vue';
  import { useToast } from 'vue-toastification';
  import { __ } from '@/helpers';

  const props = defineProps({
    data: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      required: true,
      default: () => ({})
    },
    template: {
      type: Object,
      required: true,
    }
  });

  const data = reactive(props.data);
  const toast = useToast();
  const isLoading = ref(false);

  const handleSubmit = async () => {
    isLoading.value = true;
    try {
      const response = await axios.post(
        route('redesign.company.templates.update', props.template.id),
        data
      );
      toast.success(response.data?.message);
      setTimeout(() => {
        window.location.href = route('redesign.company.templates.index');
      }, 1200);
    } catch (error) {
      toast.error(error.response?.data?.message || __('An unexpected error occurred. Please try again later.'));
    } finally {
      isLoading.value = false;
    }
  };

</script>
